import CustomReactPlayer, { CustomReactPlayerMethods, CustomReactPlayerProps} from "app/components/videos/CustomReactPlayer";
import 'app/components/videos/video.css';

interface VideoPlayerProps {
  playerRef: React.Ref<CustomReactPlayerMethods> | CustomReactPlayerProps | null;
  url: string;
  loop: boolean;
  progressInterval?: number;
  setCurrentTime: React.Dispatch<React.SetStateAction<number>>;
}

export default function VideoPlayer({ playerRef, url, loop, progressInterval, setCurrentTime }: VideoPlayerProps) {
  return (
    <>
      <CustomReactPlayer
        id="video-player"
        ref={playerRef as React.Ref<CustomReactPlayerMethods>}
        onProgress={(progress) => {
          setCurrentTime(progress.playedSeconds);
        }}
        controls={true}
        loop={loop}
        progressInterval={progressInterval || 10}
        url={url}
      />
    </>
  );
}
